"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.agent.speaking': 'El agente está hablando',
    'conversation.agent.thinking': 'El agente está pensando...',
    'conversation.agent.demo': 'Demo de Agente de Voz',
    'conversation.agent.demo.description': 'Conversación de voz interactiva con agentes de IA utilizando reconocimiento y síntesis de voz avanzados',
};
